import React from "react";
import { Facebook } from "lucide-react";
import { CONTACT } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] text-white py-16">
      <div className="max-w-4xl mx-auto px-5 md:px-8 text-center">
        <div className="font-serif-cinzel text-[22px] sm:text-[30px] md:text-[38px] tracking-[0.06em]">
          <span className="text-white font-medium">AVENTA </span>
          <span className="text-[#c79a5b] font-extrabold">REKONSTRUKCE</span>
        </div>

        <p className="mt-5 text-[15px] text-white/70">
          <a
            href={`tel:${CONTACT.phone.replace(/\s/g, "")}`}
            className="hover:text-[#c79a5b] transition-colors"
          >
            {CONTACT.phone}
          </a>{" "}
          ·{" "}
          <a
            href={`mailto:${CONTACT.email}`}
            className="hover:text-[#c79a5b] transition-colors"
          >
            {CONTACT.email}
          </a>
        </p>
        <p className="mt-2 text-[15px]">
          <a
            href={`https://${CONTACT.web}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#c79a5b] hover:opacity-80 transition-opacity"
          >
            {CONTACT.web}
          </a>
        </p>

        <div className="mt-6 flex justify-center">
          <a
            href="https://www.facebook.com/profile.php?id=61592229810332"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="inline-flex items-center justify-center w-11 h-11 border border-white/20 text-white hover:bg-[#c79a5b] hover:border-[#c79a5b] hover:text-[#1b2b45] transition-colors"
          >
            <Facebook size={20} />
          </a>
        </div>

        <div className="mt-8 pt-8 border-t border-white/10 text-[13px] text-white/45 space-y-1.5">
          <p>{CONTACT.company} · IČO: {CONTACT.ico}</p>
          <p>{CONTACT.address}</p>
          <p className="pt-3">© 2026 Aventa Rekonstrukce. Všechna práva vyhrazena.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
